import React, { Component } from 'react'
import { Button } from 'reactstrap'
import { ErrorMessage } from './'
import resendInvite from '../../../../../../helpers/users/manageUsers/resendInvite';
import { BeatLoader } from 'react-spinners'

class ResendInvite extends Component {
  state = {
    sending: false,
    error: '',
    sent: false,
  }

  // fix to where it's resending the Invite, not the password reset!!!!

  resendInv = () => {
    const { record } = this.props
    this.setState({sending: true, error: '', sent: false})
    resendInvite(record)
      .then(() => this.setState({sending: false, error: '', sent: true}))
      .catch((err) => {
        this.setState({sending: false, error: 'Error re-sending invite.', sent: false})
      })
  }

  render() {
    const { sending, error, sent } = this.state
    return (
      <div>
        Registration Invite:
        <Button
          style={{"borderRadius":"150px"}}
          className='resend-invite'
          onClick={this.resendInv}
          disabled={!!(sent || sending)}
        >
          {sending
            ? <BeatLoader loading={sending} />
            : (sent ? 'Re-Sent' : 'Re-Send')}
        </Button>
        {error
          ? <ErrorMessage>{error}</ErrorMessage>
          : null
        }
      </div>
    )
  }
}

export default ResendInvite


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/ResendInvite.js